import { GraftConfig as ArtifactFeedGraftConfig } from '@graft/nuget-gc.webportals.artifactfeeds'

import { readGraftWebserviceUrl } from '@common/config/utils/read-graft-webservice-url.util'

const artifactUrl = readGraftWebserviceUrl('ARTIFACT')

if (artifactUrl) {
  ArtifactFeedGraftConfig.host = artifactUrl
  ArtifactFeedGraftConfig.stateless = true
}
